import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

interface CommentOpinionSelector {
    opinion: OpinionTypes;
    changeOpinion: (newOpinion: OpinionTypes) => void;
    type?: keyof typeof OPINIONS;
}

const CommentOpinionSelector: React.FC<CommentOpinionSelector> = ({ opinion, changeOpinion, type }) => {
    return (
        <FormControl sx={{ width: "18rem" }}>
            <InputLabel id="comment-opinion-label">Your Opinion</InputLabel>
            <Select
                labelId="comment-opinion-label"
                id="comment-opinion-select"
                value={opinion}
                label="Your Opinion"
                onChange={(e) => changeOpinion(e.target.value as OpinionTypes)}
            >
                {getOpinionsList(type)}
            </Select>
        </FormControl>
    );

    function getOpinionsList(type: keyof typeof OPINIONS = "regular") {
        return Object.keys(OPINIONS[type]).map((opinion, index) => {
            return (
                <MenuItem key={`${opinion}-${index}`} value={opinion}>
                    {opinion}
                </MenuItem>
            );
        });
    }
};

const RegularOpinions = {
    Neutral: "Neutral",
    Support: "Support",
    Object: "Object",
} as const;
const ConsulteeOpinions = {
    ...RegularOpinions,
    Request: "Request",
    Other: "Other",
} as const;

type RegularOpinionTypes = typeof RegularOpinions[keyof typeof RegularOpinions];
type ConsulteeOpinionTypes = typeof ConsulteeOpinions[keyof typeof ConsulteeOpinions];

type Opinions = {
    consultee: typeof ConsulteeOpinions;
    regular: typeof RegularOpinions;
};
export type OpinionTypes = RegularOpinionTypes | ConsulteeOpinionTypes;
export const OPINIONS: Opinions = {
    consultee: ConsulteeOpinions,
    regular: RegularOpinions,
};
export default CommentOpinionSelector;
